export const MAX_PREVIEW_PERC = 0.99;
export const BAR_WIDTH = 3;
export const BAR_MARGIN = 1;

export const BOTTOM_WAVE_HEIGHT = 2 / 5;
export const SONG_TOP_WAVE_HEIGHT = 0.64;
export const SONG_BOTTOM_WAVE_HEIGHT = 0.48;

export const getColor = ({
  state,
  gradient,
}: {
  state: 'played' | 'unplayed';
  gradient?: boolean;
}) => {
  if (state === 'unplayed') {
    return gradient ? 'hsla(214, 8%, 84%, .5)' : 'hsla(214, 8%, 84%, 1)';
  }

  return 'hsla(160, 84%, 39%, 1)';
};
